module.exports = __webpack_public_path__ + "img/talk-o.24133cb6.gif";